export default class KbygParams {
  public groupCk?: string;
  public groupId?: string;
  public classId?: string;
  public classPlanId?: string;
  public showEye360?: string;
  public packageId?: string;
  public clientId?: string;

  constructor(data: any) {
    this.groupCk = data.groupCk;
    this.groupId = data.groupId;
    this.classId = data.classId;
    this.classPlanId = data.classPlanId;
    this.showEye360 = data.showEye360;
    this.packageId = data.packageId;
    this.clientId = data.clientId;
  }

  static of(data: any): KbygParams {
    return new KbygParams(data);
  }
}
